const framerAnimationFade = {
  initial: {
    opacity: 0
  },
  animate: {
    opacity: 1
  },
  exit: {
    opacity: 0
  },
  transition: {
    delay: 0.05,
    duration: 0.2
  }
};
const framerAnimationSlideUp = {
  initial: {
    opacity: 0,
    y: "100%"
  },
  exit: {
    opacity: 0,
    y: "100%"
  },
  animate: {
    opacity: 1,
    y: 0
  },
  transition: {
    delay: 0.05,
    duration: 0.2
  }
};
const framerAnimationFadeInExpandWidth = {
  initial: {
    opacity: 0,
    width: "70%"
  },
  animate: {
    opacity: 1,
    width: "100%"
  },
  transition: {
    delay: 0.5,
    duration: 0.3
  }
};

export { framerAnimationFade, framerAnimationFadeInExpandWidth, framerAnimationSlideUp };
//# sourceMappingURL=framerAnimations.js.map
